(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  if (!customElements.get('expandable-product-description')) {
    class ExpandableProductDescription extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;

        this.dataset.initialized = 'true';
        this.content = this.querySelector('.product-description-toggle__content');
        this.inner = this.querySelector('.product-description-toggle__inner');
        this.button = this.querySelector('.product-description-toggle__button');
        this.collapsedHeight = Number.parseFloat(this.dataset.collapsedHeight) || 180;
        this.isExpanded = false;

        if (!this.content || !this.inner || !this.button) return;

        this.handleToggle = this.handleToggle.bind(this);
        this.handleTransitionEnd = this.handleTransitionEnd.bind(this);
        this.refresh = this.refresh.bind(this);

        this.button.addEventListener('click', this.handleToggle);
        this.content.addEventListener('transitionend', this.handleTransitionEnd);

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => {
            window.requestAnimationFrame(this.refresh);
          });
          this.resizeObserver.observe(this.inner);
        }

        this.querySelectorAll('img').forEach((image) => {
          if (!image.complete) image.addEventListener('load', this.refresh, { once: true });
        });

        window.requestAnimationFrame(() => {
          this.dataset.ready = 'true';
          this.refresh();
        });
      }

      disconnectedCallback() {
        this.button?.removeEventListener('click', this.handleToggle);
        this.content?.removeEventListener('transitionend', this.handleTransitionEnd);
        this.resizeObserver?.disconnect();
      }

      getFullHeight() {
        return Math.ceil(this.inner.scrollHeight);
      }

      refresh() {
        if (!this.content || !this.inner) return;

        const fullHeight = this.getFullHeight();
        const hasOverflow = fullHeight > this.collapsedHeight + 2;
        this.dataset.overflow = String(hasOverflow);

        if (!hasOverflow) {
          this.isExpanded = false;
          this.dataset.state = 'collapsed';
          this.button.setAttribute('aria-expanded', 'false');
          this.content.style.height = 'auto';
          return;
        }

        if (this.isExpanded) {
          this.content.style.height = 'auto';
        } else {
          this.content.style.height = `${this.collapsedHeight}px`;
        }
      }

      handleToggle() {
        const fullHeight = this.getFullHeight();

        if (this.isExpanded) {
          this.content.style.height = `${fullHeight}px`;
          void this.content.offsetHeight;
          this.isExpanded = false;
          this.dataset.state = 'collapsed';
          this.button.setAttribute('aria-expanded', 'false');
          window.requestAnimationFrame(() => {
            this.content.style.height = `${this.collapsedHeight}px`;
          });
        } else {
          const currentHeight = this.content.getBoundingClientRect().height;
          this.content.style.height = `${currentHeight}px`;
          void this.content.offsetHeight;
          this.isExpanded = true;
          this.dataset.state = 'expanded';
          this.button.setAttribute('aria-expanded', 'true');
          window.requestAnimationFrame(() => {
            this.content.style.height = `${fullHeight}px`;
          });
        }
      }

      handleTransitionEnd(event) {
        if (event.propertyName !== 'height' || event.target !== this.content) return;
        if (this.isExpanded) this.content.style.height = 'auto';
      }
    }

    customElements.define('expandable-product-description', ExpandableProductDescription);
  }

  } catch(e) { console.error(e); }
})();
})();
